const Audio = require('../build/react-audioplayer.js');

module.exports = Audio;
